import * as Yup from 'yup';

export const bankSchema = Yup.object({
   bank_name: Yup.string()
      .trim()
      .required('Bank name is required')
      .min(2, 'Bank name must be at least 2 characters')
      .max(100, 'Bank name should be at most 100 characters long')
      .test(
         'not-only-spaces',
         'Bank name cannot be empty',
         (value) => !!value?.trim()
      ),

   account_no: Yup.string()
      .trim()
      .required('Account number is required')
      .min(5, 'Account number must be at least 5 characters')
      .max(30, 'Account number must be at most 30 characters'),

   account_type: Yup.string().trim().nullable(),

   other_fields: Yup.array().of(
      Yup.object({
         label: Yup.string().trim().required('Label is required'),
         value: Yup.string().trim().required('Value is required'),
      })
   ),
});